

import classes from './TextAreaInput.module.scss';

const TextAreaInput = ({
    input,
    className,
    horizontal = false,
    maxLength = null,
}) => {
    return (
        <div
            className={`${horizontal ? 'row d-flex flex-row' : 'd-flex flex-column'} ${classes['textinput-wrapper']
                } ${className || ' '} `}>
            <label htmlFor={input.id} className={`${horizontal ? 'col-12 col-xl-4' : ''}`}>
                {input.label}
            </label>

            <textarea
                className={`
                    ${input.value && maxLength && input.value.length > maxLength ? classes['invalid'] : ''}
                    ${horizontal ? 'col-12 col-xl-8' : ''}
                    ${input.label ? '' : 'col-12 col-xl-12'}`}
                rows={6}
                {...input}
                onChange={(e) => {
                    if (maxLength && e.target.value.length > maxLength) {
                        return;
                    }
                    input.onChange(e);
                }}
            />
            {maxLength && (
                <span className={classes['text-length']}>
                    {input.value ? input.value.length : 0}/{maxLength}
                </span>
            )}
        </div>
    );
};

export default TextAreaInput;
